import { createSelector } from '@reduxjs/toolkit'
import { getLibrary } from 'model/selectors/base'
import orderBy from 'lodash/orderBy'

export const getSortedLibraryCourses = createSelector([getLibrary], courses => {
  return orderBy(courses, 'createdAt', 'desc')
})
